// VWO Campaign Group Utility
// Determines which VWO campaign group a property belongs to based on environment variables

/**
 * Get VWO campaign group for a property slug
 * @param {string} propertySlug - Property slug identifier
 * @returns {string|null} Campaign group (groupA, groupB) or null if property should not be in any campaign
 */
export const getVWOCampaignGroup = (propertySlug) => {
  if (typeof window === 'undefined') return null;
  
  // Get property groups from environment variables (these are set at build time)
  const vwoPropertyGroupA = process.env.GATSBY_VWO_PROPERTY_GROUP_A?.split(',').map(slug => slug.trim()) || [];
  const vwoPropertyGroupB = process.env.GATSBY_VWO_PROPERTY_GROUP_B?.split(',').map(slug => slug.trim()) || [];
  
  if (vwoPropertyGroupA.includes(propertySlug)) return 'groupA';
  if (vwoPropertyGroupB.includes(propertySlug)) return 'groupB';
  
  return null; // No VWO campaign for properties not in any group
};

/**
 * Extract property slug from current URL path
 * @returns {string|null} Property slug or null if not on a property page
 */
export const extractPropertySlugFromUrl = () => {
  if (typeof window === 'undefined') return null;
  
  const path = window.location.pathname;
  // Match pattern: /apartments/{area}/{city}/{property-slug}/...
  const match = path.match(/\/apartments\/[^\/]+\/[^\/]+\/([^\/]+)/);
  return match ? match[1] : null;
};

/**
 * Get VWO campaign group for current page
 * @returns {string|null} Campaign group for current property or null if no campaign
 */
export const getCurrentVWOCampaignGroup = () => {
  const propertySlug = extractPropertySlugFromUrl();
  if (!propertySlug) return null; // Non-property pages get no VWO
  
  return getVWOCampaignGroup(propertySlug);
};

/**
 * Get flag configuration for a campaign group
 * @param {string|null} campaignGroup - Campaign group identifier
 * @returns {Object|null} Flag configuration with flagKey and variable, or null if no campaign
 */
export const getFlagConfigForGroup = (campaignGroup) => {
  if (!campaignGroup) return null; // No flag config for properties not in groups
  
  const FLAG_CONFIGS = {
    groupA: {
      flagKey: "applyNowFormInterstitial", // Existing campaign
      variable: "show_interstitial"
    },
    groupB: {
      flagKey: "applyNowFormInterstitial_GroupB", // New campaign for Group B
      variable: "show_interstitial" 
    }
  };
  
  return FLAG_CONFIGS[campaignGroup] || null;
};
